<template>
  <article class="message">
    <div class="message-body"><slot /></div>
  </article>
</template>

<script>
export default {
  name: "message"
}
</script>

<style lang="scss">
.message {
  margin-bottom: 0.75rem;
}
</style>
